module.exports = {
      id: "fb-usage",
      viewBox: "0 0 20 20",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#fb",
      toString: function () {
        return this.url;
      }
    }